import { apiClient } from '../../utils/apiClient';

// Get all users
const getAllUsers = async () => {
  const { data } = await apiClient.get('users/');
  
  // Backend returns { users: [...], pagination: {...} }
  const usersArray = data.users || data;
  
  if (Array.isArray(usersArray)) {
    if (usersArray.length > 0) {
      // Parse user roles from userRoles[].role.name structure
      if (usersArray[0]?.userRoles) {
        const roles = usersArray[0].userRoles.map(ur => ur.role?.name).filter(Boolean);
      }
    }
    
    // Transform users to extract roles correctly and normalize field names
    return usersArray.map(user => ({
      ...user,
      // Normalize field names from backend snake_case to frontend camelCase
      lastLogin: user.last_login || user.lastLogin,
      isActive: user.is_active !== undefined ? user.is_active : user.isActive,
      createdAt: user.created_at || user.createdAt,
      updatedAt: user.updated_at || user.updatedAt,
      // Extract role names from userRoles[].role.name structure
      roles: user.userRoles ? user.userRoles.map(ur => ur.role?.name).filter(Boolean) : []
    }));
  } else {
    console.warn('Expected users array but got:', typeof usersArray);
  }
  
  return usersArray || [];
};

// Get user by ID
const getUserById = async (userId) => {
  // Console log removed for production
  const { data } = await apiClient.get(`users/${userId}`);
  // Console log removed for production
  // Console log removed for production
  // Console log removed for production
  // Console log removed for production
  
  if (data && data.userRoles) {
    // Extract role names from userRoles[].role.name structure
    const roles = data.userRoles.map(ur => ur.role?.name).filter(Boolean);
  // Console log removed for production
    
    return {
      ...data,
      roles: roles
    };
  }
  
  return data;
};

// Create new user
const createUser = async (userData) => {
  const { data } = await apiClient.post('users/', userData);
  return data;
};

// Update user
const updateUser = async (userId, userData) => {
  const { data } = await apiClient.put(`users/${userId}`, userData);
  return data;
};

// Delete user
const deleteUser = async (userId) => {
  const { data } = await apiClient.delete(`users/${userId}`);
  return data;
};

const userService = {
  getAllUsers,
  getUserById,
  createUser,
  updateUser,
  deleteUser
};

export default userService;
